<template>
  <v-container-principal>
    <template #header>
      <v-cabecalho
        nomePagina="Todas as salas"
        buscaPlaceHolder="Buscar sala por nome"
        backTo="/"
        :search="selecao.textoPesquisado"
        v-on:search="(value) => (selecao.textoPesquisado = value)">
        <v-cabecalho-btn
          v-if="isAdministrador"
          pathTo="criarSala"
          icone="mdi-plus"
          descricao="Criar Sala">
        </v-cabecalho-btn>
      </v-cabecalho>
    </template>

    <template #filter>
      <v-filtro>
        <template v-slot:bloco>
          <v-select
            v-model="selecao.bloco"
            :items="blocoNomes"
            @change="loadSalasAndUpdateURL"
            label="Todos os blocos"></v-select>
        </template>
        <template v-slot:andar>
          <v-select
            v-model="selecao.andar"
            :items="andares"
            @change="loadSalasAndUpdateURL"
            label="Todos os pisos"></v-select>
        </template>
        <template v-slot:capacidade>
          <v-text-field
            type="number"
            min="1"
            v-model="selecao.capacidade"
            @input="loadSalasAndUpdateURL"
            label="Capacidade"></v-text-field>
        </template>
        <template v-slot:computadores>
          <v-text-field
            type="number"
            min="0"
            v-model="selecao.computadores"
            @input="loadSalasAndUpdateURL"
            label="Nº de Computadores"></v-text-field>
        </template>
        <template v-slot:equipamentos>
          <v-select
            multiple
            v-model="selecao.equipamentos"
            :items="equipamentos"
            @change="loadSalasAndUpdateURL"
            label="Equipamento">
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index === 0">
                <span>{{ item }}</span>
              </v-chip>
              <span v-if="index === 1" class="grey--text text-caption">
                +{{ selecao.equipamentos.length - 1 }}
                outros
              </span>
            </template>
          </v-select>
        </template>
        <template v-slot:disponibilidade>
          <v-select
            v-model="selecao.disponibilidade"
            :items="disponibilidade"
            @change="loadSalasAndUpdateURL"
            label="Disponibilidade"></v-select>
        </template>
      </v-filtro>
    </template>

    <v-data-iterator
      :items="arraySalas"
      :options.sync="options"
      :items-per-page="footerProps.pagination.itemsPerPage"
      :server-items-length="footerProps.pagination.itemsLength"
      :footer-props="footerProps"
      :loading="loading"
      @update:page="updatePage"
      @update:items-per-page="updateItemsPerPage">
      <template v-slot:default="props">
        <v-row>
          <v-col
            v-for="item in props.items"
            :key="item.id"
            cols="12"
            md="6"
            lg="6"
            xl="4">
            <v-card-sala
              :id="item.id"
              :nome="item.attributes.nome"
              :responsavel="item.attributes.responsavel"
              :capacidade="item.attributes.capacidade"
              :computadores="item.attributes.computadores"
              :localizacaosala="item.attributes.bloco.data.attributes.descricao"
              :localizacaoandar="item.attributes.andar"
              :mesa="item.attributes.mesa"
              :projetor="item.attributes.projetor"
              :arcondicionado="item.attributes.arcondicionado"
              :lousa="item.attributes.lousa"
              :disponivel="item.attributes.disponivel"
              @delete="deletarSala" />
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
  </v-container-principal>
</template>

<script>
import VContainerPrincipal from "../../components/VContainerPrincipal"
import VCabecalho from "../../components/VCabecalho"
import VFiltro from "../../components/VFiltro"
import VCardSala from "../../components/VCardSala"
import VSelect from "../../components/base/VSelect"
import VTextField from "../../components/base/VTextField"
import { RepositoryFactory } from "../../repositories/repositoryFactory"
import { mapActions, mapGetters } from "vuex"
import VCabecalhoBtn from "../../components/VCabecalhoBtn"

const blocoRepository = RepositoryFactory.get("bloco")
const salaRepository = RepositoryFactory.get("sala")

const DISPONIVEL = "Disponível"
const INDISPONIVEL = "Indisponível"
const DISPONIVEIS_E_INDISPONIVEIS = "Todos"
const TODOS_OS_BLOCOS = "Todos os blocos"
const TODOS_OS_ANDARES = "Todos os pisos"
const ARCONDICIONADO = "Ar condicionado"
const LOUSA = "Lousa"
const MESA = "Mesa"
const PROJETOR = "Projetor"
const EXCLUSAO_SUCESSO = "A exclusão da sala foi realizada com sucesso!"

export default {
  components: {
    VContainerPrincipal,
    VCabecalho,
    VFiltro,
    VCardSala,
    VSelect,
    VTextField,
    VCabecalhoBtn,
  },

  data: () => ({
    arraySalas: [],
    blocos: [],
    disponibilidade: [DISPONIVEL, INDISPONIVEL, DISPONIVEIS_E_INDISPONIVEIS],
    equipamentos: [ARCONDICIONADO, LOUSA, PROJETOR, MESA],
    delayPesquisa: null,
    loading: true,
    options: {
      page: 1,
      itemsPerPage: Number(localStorage.getItem("salas.itemsPerPage")) || 8,
    },

    selecao: {
      textoPesquisado: "",
      capacidade: "",
      computadores: "",
      andar: undefined,
      bloco: undefined,
      disponibilidade: DISPONIVEIS_E_INDISPONIVEIS,
      equipamentos: [],
    },
  }),
  watch: {
    "selecao.textoPesquisado": {
      handler() {
        if (this.delayPesquisa) {
          clearTimeout(this.delayPesquisa)
          this.delayPesquisa = null
        }
        this.delayPesquisa = setTimeout(() => {
          this.loadSalas({ page: 1 })
          this.$router.replace({ query: { ...this.selecao } })
        }, 200)
      },
    },
  },

  async mounted() {
    if (typeof this.$route.query.equipamentos === "string") {
      this.$route.query.equipamentos = [this.$route.query.equipamentos]
    }

    this.selecao = Object.assign(this.selecao, this.$route.query)

    const {
      data: { data: blocosData },
    } = await blocoRepository.getAll()

    this.blocos = blocosData

    this.loadSalas()
  },
  computed: {
    footerProps() {
      return {
        itemsPerPageText: "Itens por página",
        itemsPerPageOptions: [8, 16, 24, 32],
        pagination: {
          page: this.options.page,
          itemsPerPage: this.options.itemsPerPage,
          pageStart: 1,
          itemsLength: null,
        },
      }
    },
    blocoNomes() {
      return [
        ...this.blocos.map((b) => b.attributes.descricao),
        TODOS_OS_BLOCOS,
      ]
    },
    andares() {
      let maxAndares = 0
      for (const bloco of this.blocos) {
        maxAndares = Math.max(bloco.attributes.quantidadeAndar)
      }
      return [
        ...Array.from(Array(maxAndares).keys(), (x) => x + 1),
        TODOS_OS_ANDARES,
      ]
    },
    ...mapGetters({
      isAdministrador: ["auth/isAdministrador"],
      isPrefeitura: ["auth/isPrefeitura"],
      userId: ["auth/userId"],
    }),
  },
  methods: {
    async loadSalas({
      page = this.footerProps.pagination.page,
      itemsPerPage = this.footerProps.pagination.itemsPerPage,
    } = {}) {
      this.loading = true
      const blocoSelecionado = this.blocos.find(
        (b) => b.attributes.descricao === this.selecao.bloco
      )
      const andar =
        this.selecao.andar !== TODOS_OS_ANDARES ? this.selecao.andar : undefined
      const disponibilidade = this.getDisponibilidadeAsBoolean()
      salaRepository
        .searchBy(page, itemsPerPage, {
          nome: this.selecao.textoPesquisado,
          capacidade: this.selecao.capacidade,
          computadores: this.selecao.computadores,
          andar,
          bloco: blocoSelecionado ? blocoSelecionado.id : undefined,
          disponibilidade,
          equipamentos: this.selecao.equipamentos,
        })
        .then((res) => {
          this.loading = false
          this.arraySalas = res.data.data
          this.footerProps.pagination.itemsLength =
            res.data.meta.pagination.total
        })
    },
    async loadSalasAndUpdateURL() {
      await this.loadSalas()
      this.$router.replace({ query: { ...this.selecao } })
    },
    getDisponibilidadeAsBoolean() {
      switch (this.selecao.disponibilidade) {
        case DISPONIVEL:
          return true
        case INDISPONIVEL:
          return false
        default:
          return undefined
      }
    },
    updatePage(page) {
      this.loadSalas({ page })
    },

    updateItemsPerPage(itemsPerPage) {
      localStorage.setItem("salas.itemsPerPage", itemsPerPage)
      this.loadSalas({ itemsPerPage })
    },
    deletarSala(id) {
      salaRepository
        .delete(id)
        .then(() => {
          this.showSucesso(EXCLUSAO_SUCESSO)
          this.loadSalas()
        })
        .catch((error) => {
          this.showError(error.response.data.error.message)
        })
    },
    ...mapActions("message", ["showSucesso", "showErro"]),
  },
}
</script>
